<div class="dialoghead">
    <h1 class="mat-mdc-dialog-title"> Alert !!</h1>
    <mat-dialog-content>
      <p>Congratulations on completing all required trainings! Would you like to proceed with the optional training sessions, or would you prefer to book a gameplan call?</p>
    </mat-dialog-content>
    <div class="mat-mdc-dialog-actions">
      <button mat-button (click)="goToDashboard('no')">Proceed to Optional Trainings</button>
      <button mat-button (click)="goToDashboard('gameplanbook')">Book a Gameplan Call</button>
    </div>
  </div>
